import { render } from "./Planos.vue?vue&type=template&id=3bc1559f"
import script from "./Planos.vue?vue&type=script&lang=js"
export * from "./Planos.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielalencar/Documents/custom/gestio-school-frontend-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__